import moment from 'moment';

const WEEK_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// calendar rules come with the week day as a number (0 - Sunday) or as a name ('Monday')
export const weekDayIndex = (weekDay) => (typeof weekDay === 'number' ? weekDay : WEEK_DAYS.indexOf(weekDay));

const pad = (value) => value.toString().padStart(2, '0');
const formatHour = (minutes) => `${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`;

// the same format as the timetable column in the offer import, e.g. "pon, śr 16:00-17:30; pt 10:00-11:00"
export const formatTimetable = (rules) => {
  const groups = {};
  (rules || []).forEach((r) => {
    const key = `${formatHour(r.startMinutes)}-${formatHour(r.startMinutes + r.durationMinutes)}`;
    // Monday first
    const day = (weekDayIndex(r.weekDay) + 6) % 7;
    groups[key] = groups[key] || { key, start: r.startMinutes, days: [] };
    if (!groups[key].days.includes(day)) {
      groups[key].days.push(day);
    }
  });

  return Object.values(groups)
    .map((g) => ({ ...g, days: g.days.sort((a, b) => a - b) }))
    .sort((a, b) => a.days[0] - b.days[0] || a.start - b.start)
    .map((g) => `${g.days.map((d) => moment.weekdaysShort((d + 1) % 7)).join(', ')} ${g.key}`)
    .join('; ');
};
